<!--
    DrippingMetalPendant
    滴胶金属挂件？  
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="挂件 > 金属挂件 > 滴胶工艺" name="滴胶工艺">
        <el-row>
          <el-col :span="24">
            <el-form
              :label-position="labelPosition"
              :model="drippingMetalPendantForm"
              label-width="80px"
            >
              <el-form-item label="边缘色">
                <el-input v-model="drippingMetalPendantForm['边缘色']" placeholder="默认白色"></el-input>
              </el-form-item>
              <el-form-item label="底板颜色">
                <el-select v-model="drippingMetalPendantForm['底板颜色']" placeholder="请选底板颜色">
                  <el-option label="银色" value="银色"></el-option>
                  <el-option label="金色" value="金色"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="配件">
                <el-select v-model="drippingMetalPendantForm['配件']" placeholder="请选择配件">
                  <el-option label="龙虾扣" value="龙虾扣"></el-option>
                  <el-option label="手机绳" value="手机绳"></el-option>
                  <el-option label="银色D字扣" value="银色D字扣"></el-option>
                  <el-option label="钥匙圈" value="钥匙圈"></el-option>
                  <el-option label="星星形" value="星星形"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="尺寸">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="drippingMetalPendantForm['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="drippingMetalPendantForm['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="drippingMetalPendantForm['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number
                  v-model="drippingMetalPendantForm['数量']"
                  :min="100"
                  :max="10000"
                  label="数量"
                ></el-input-number>
                <el-alert title="单款起定数为100;" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin: 20px 0 0 0;"></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button> <el-button v-on:click="clear()">清空</el-button> 
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>

<script>
export default {
  name: "DrippingMetalPendant",
  data() {
    return {
      forcollapse: ['allsame'],
      drippingMetalPendantForm: {
        title: "滴胶工艺金属挂件",
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.drippingMetalPendantForm);
       
    },
    clear() {
      this.$root.clearAlert()
      this.drippingMetalPendantForm = {
        title: "滴胶工艺金属挂件",
      };
    }
  }
};
</script>


<style scoped>
</style>
